import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import PageSkeleton from '../components/ui/PageSkeleton';
import ImpersonationBanner from './common/ImpersonationBanner';

export default function ProtectedRoute() {
    const initialized = useAuthStore((state) => state.initialized);
    const user = useAuthStore((state) => state.user);

    if (!initialized) {
        return <PageSkeleton />;
    }

    if (!user) {
        return <Navigate to="/" replace />;
    }

    return (
        <>
            <ImpersonationBanner />
            <Outlet />
        </>
    );
}
